export default {
    bold: 'GerberaBold,   "Segoe UI", "Droid Sans", Roboto, Helvetica, Arial, sans-serif',
    black: 'GerberaBlack,  "Segoe UI", "Droid Sans", Roboto, Helvetica, Arial, sans-serif',
    light: 'GerberaLight,  "Segoe UI", "Droid Sans", Roboto, Helvetica, Arial, sans-serif',
    medium: 'GerberaMedium, "Segoe UI", "Droid Sans", Roboto, Helvetica, Arial, sans-serif',
    regular: 'GerberaRegular,"Segoe UI", "Droid Sans", Roboto, Helvetica, Arial, sans-serif',
};
